/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShowCar200ResponseDataVideosInner
 */
export interface ShowCar200ResponseDataVideosInner {
    /**
     * 
     * @type {number}
     * @memberof ShowCar200ResponseDataVideosInner
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ShowCar200ResponseDataVideosInner
     */
    carId?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowCar200ResponseDataVideosInner
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowCar200ResponseDataVideosInner
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof ShowCar200ResponseDataVideosInner
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowCar200ResponseDataVideosInner
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowCar200ResponseDataVideosInner
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ShowCar200ResponseDataVideosInner interface.
 */
export function instanceOfShowCar200ResponseDataVideosInner(value: object): value is ShowCar200ResponseDataVideosInner {
    return true;
}

export function ShowCar200ResponseDataVideosInnerFromJSON(json: any): ShowCar200ResponseDataVideosInner {
    return ShowCar200ResponseDataVideosInnerFromJSONTyped(json, false);
}

export function ShowCar200ResponseDataVideosInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowCar200ResponseDataVideosInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'carId': json['car_id'] == null ? undefined : json['car_id'],
        'url': json['url'] == null ? undefined : json['url'],
        'title': json['title'] == null ? undefined : json['title'],
        'position': json['position'] == null ? undefined : json['position'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ShowCar200ResponseDataVideosInnerToJSON(json: any): ShowCar200ResponseDataVideosInner {
    return ShowCar200ResponseDataVideosInnerToJSONTyped(json, false);
}

export function ShowCar200ResponseDataVideosInnerToJSONTyped(value?: ShowCar200ResponseDataVideosInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'car_id': value['carId'],
        'url': value['url'],
        'title': value['title'],
        'position': value['position'],
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

